import { EntityCfgOverrides } from '@core/models/entities/generic-entity-cfg';
import { CustomData } from '@core/models/entities/implementations/custom-data';
import { GenericEntityRegistryService } from '@core/services/user-models-registry/generic-entity-registry.service';
import { isNil } from '@core/utils/shared-utils';

import { TimeWindow } from './time-window';

export interface WorkBreakRegulation {
  max_duration_without_short_break: string;
  max_duration_without_long_break: string;
  short_break_duration: string;
  long_break_duration: string;
  min_break_duration?: string;
}

export interface DriveBreakRegulation {
  max_duration_without_break: string;
  full_break_duration: string;
  preempted_break_duration?: string;
}

export interface ShiftRegulation {
  max_duration: string;
  max_work_duration: string;
  max_driving_duration: string;
  max_total_wait_duration: string;
}

export interface WeekRegulation {
  max_duration: string;
  max_work_duration: string;
  max_driving_duration: string;
  max_total_wait_duration: string;
  full_rest_duration: string;
  preempted_rest_duration?: string;
  resumed_rest_duration?: string;
  max_nb_days_in_week: number;
}

export interface UserWorkRegulationV1Model {
  uid: string;
  break_at_site: boolean;
  is_allowed_night_shift: boolean;
  work_break_constraint?: WorkBreakRegulation;
  drive_break_constraint?: DriveBreakRegulation;
  break_window?: TimeWindow;
  shift_constraint?: ShiftRegulation;
  week_constraint?: WeekRegulation;
  night_shift_window?: TimeWindow;
  night_shift_max_work_duration: string;
  custom_data: CustomData;
}

function indicateIfConstraintsExist(constraint: unknown): string {
  if (typeof constraint === 'object' && !isNil(constraint)) {
    return 'Defined';
  } else {
    return '';
  }
}

const constraintColumnKeys = new Set([
  'raw.work_break_constraint',
  'raw.drive_break_constraint',
  'raw.break_window',
  'raw.shift_constraint',
  'raw.week_constraint',
  'raw.night_shift_window'
]);

export function registerWorkRegulationExtensions(
  registry: GenericEntityRegistryService
): void {
  const overrides: EntityCfgOverrides<UserWorkRegulationV1Model> = {
    buildColumns: (autoColumns) =>
      autoColumns.map((col) =>
        constraintColumnKeys.has(col.key as string)
          ? { ...col, renderHook: (value: unknown) => indicateIfConstraintsExist(value) }
          : col
      )
  };
  registry.registerOverrides('UserWorkRegulation', overrides);
}
